import React, { Component } from "react";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";

class ColourMaster extends Component {
  constructor(props) {
    super(props);
    this.commonServices = new CommonServices();
    this.itemMasterServices = new ItemMasterServices();
    this.SwalServices = new SwalServices();
    this.state = {
      _id: "",
      isEditing: false,
      isLoading: false,
      tableStatus: "",
      colorMasterList: [],
      colorDetails: {
        colorMaster: "",
      },
    };
  }

  componentDidMount() {
    this.getAllColors();
  }

  getAllColors = () => {
    this.setState({ tableStatus: "Loading..." })
    this.commonServices.getAllColors().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        if (response.responseData.length === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        this.setState(
          { colorMasterList: response.responseData });
      } else {
        this.setState({ tableStatus: "" })
        this.SwalServices.Error(response.Message);
      }
    });
  };

  addEditColors = () => {
    if (this.state.colorDetails.colorMaster !== "") {
      this.setState({ isLoading: true }, () => {
        let request = this.state.colorDetails;
        if (this.state._id && this.state._id !== "") {
          request._id = this.state._id;
        } else {
          delete request._id;
        }
        this.itemMasterServices.addEditColors(request).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.resetForm();
            this.setState({ isLoading: false })
            this.SwalServices.Success(response.Message);
          } else {
            this.SwalServices.Error(response.Message);
            this.setState({ isLoading: false })
          }
        });
      })
    } else {
      this.SwalServices.Alert("Please fill all the required things.");
    }
  };

  resetForm = () => {
    let details = this.state.colorDetails;
    details.colorMaster = "";
    this.setState({ colorDetails: details }, () => {
      this.setState({ _id: "", isEditing: false, tableStatus: "" }, () => {
        console.log(this.state._id);
        this.getAllColors();
      });
    });
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.colorDetails;
    details[name] = value.toUpperCase();
    this.setState({ colorDetails: details });
  };

  getColorById = (group) => {
    let details = this.state.colorDetails;
    details.colorMaster = group.colorMaster;
    this.setState({ colorDetails: details, _id: group._id }, () => {
      this.setState({ isEditing: true });
    });
  };

  deleteColorById = (id) => {
    this.itemMasterServices.deleteColorById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.SwalServices.Success(response.Message);
        this.resetForm();
        this.getAllColors();
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  closeGridView = () => {
    this.resetForm();
  };

  render() {
    return (
      <div className="item-category">
        <div className="item-form">
          <div className="form-table">
            <div className="item-grp !w-[50%] !mb-3.5">
              <label>Color Name</label>
              <input
                className="inputFocus"
                type="text"
                id="colorMaster"
                name="colorMaster"
                autoComplete="off"
                value={this.state.colorDetails.colorMaster}
                onChange={(event) => this.handleChange(event, "colorMaster")}
              />
            </div>
            <div className="btn-grp">
              {this.state.isEditing === true ? (
                <button
                  className="add-btn"
                  disabled={this.state.isLoading}
                  onClick={() => this.addEditColors()}
                >
                  {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                </button>
              ) : (
                <button
                  className="add-btn"
                  disabled={this.state.isLoading}
                  onClick={() => this.addEditColors()}
                >
                  {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                </button>
              )}
              <button className="cancel-btn" onClick={() => this.closeGridView()} disabled={this.state.isLoading}>
                cancel
              </button>
            </div>
          </div>
          <div className="itemList-table !w-[60%] !mt-4">
            <div className="table-container" style={{ height: 'calc(100vh - 185px)', }}>
              <table className="itemList">
                <thead>
                  <tr>
                    <td style={{ width: '85%' }}>Color Name</td>
                    <td style={{ width: '15%', textAlign: 'center' }}>Action</td>
                  </tr>
                </thead>
                <tbody>
                  {this.state.colorMasterList &&
                    this.state.colorMasterList.length > 0 ?
                    this.state.colorMasterList.map((group, key) => (
                      <tr key={key}>
                        <td>{group.colorMaster}</td>
                        <td style={{ textAlign: 'center' }}>
                          <button
                            className="search-btn"
                            onClick={() => this.getColorById(group)}
                          >
                            <FontAwesomeIcon icon={faPen} />
                          </button>
                          <button
                            className="cancel-btn"
                            onClick={() => this.deleteColorById(group._id)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </td>
                      </tr>
                    )) : this.state.colorMasterList &&
                      this.state.colorMasterList.length === 0
                      && this.state.tableStatus !== "" ? (
                      <tr>
                        <td colSpan={2} style={{ textAlign: "center", fontSize: "16px" }}>
                          {this.state.tableStatus}
                        </td>
                      </tr>
                    ) : this.state.colorMasterList &&
                      this.state.colorMasterList.length === 0
                      && this.state.tableStatus === "" ? null : ""}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ColourMaster;
